module.exports = __webpack_public_path__ + "static/img/22c.4e78818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22c.jpg
// module id = MgIY
// module chunks = 0